import { render, staticRenderFns } from "./live_replay.vue?vue&type=template&id=a09b222a&scoped=true"
import script from "./live_replay.vue?vue&type=script&lang=js"
export * from "./live_replay.vue?vue&type=script&lang=js"
import style0 from "./live_replay.vue?vue&type=style&index=0&id=a09b222a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09b222a",
  null
  
)

export default component.exports